import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { useContent } from '../context/ContentContext';

const Pricing = ({ onDownload }) => {
  const { content } = useContent();
  const plans = content.pricing;

  return (
    <div className="bg-gradient-to-b from-[#e8f5ee] to-white pt-40 pb-24 px-6 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <p className="text-sm font-semibold text-[#0e9f6e] text-center mb-3">Pricing</p>
        <h1 className="font-display text-5xl sm:text-6xl font-700 text-[#0f1712] text-center">Keep more of every sale.</h1>
        <p className="text-[#0f1712]/55 text-center max-w-xl mx-auto mt-5">
          Flat, honest rates that never change with your revenue. No setup, no monthly bill, no surprises.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {plans.map((p, idx) => (
            <div key={idx} className={`rounded-3xl p-8 border transition-transform hover:-translate-y-1 ${p.highlight ? 'bg-[#0b1510] border-transparent shadow-xl' : 'bg-white border-[#0f1712]/10'}`}>
              {p.highlight && <span className="inline-block text-xs font-semibold text-[#0b1510] bg-[#3ddc9a] rounded-full px-3 py-1 mb-4">Most popular</span>}
              <h3 className={`font-display text-2xl font-700 ${p.highlight ? 'text-white' : 'text-[#0f1712]'}`}>{p.name}</h3>
              <div className="flex items-end gap-2 mt-5">
                <span className={`font-display text-5xl font-700 ${p.highlight ? 'text-[#3ddc9a]' : 'text-[#0e9f6e]'}`}>{p.price}</span>
                <span className={`text-sm mb-2 ${p.highlight ? 'text-white/50' : 'text-[#0f1712]/50'}`}>{p.unit}</span>
              </div>
              <ul className="mt-8 space-y-3">
                {(p.features || []).map((f) => (
                  <li key={f} className={`flex items-center gap-3 text-sm ${p.highlight ? 'text-white/75' : 'text-[#0f1712]/75'}`}>
                    <Check size={16} className="text-[#0e9f6e] shrink-0" /> {f}
                  </li>
                ))}
              </ul>
              <button onClick={onDownload} className={`w-full mt-8 inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3.5 text-sm font-semibold transition-colors ${p.highlight ? 'bg-[#0e9f6e] text-white hover:bg-[#0c8a60]' : 'bg-[#0f1712] text-white hover:bg-black'}`}>
                Get started <ArrowRight size={15} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;
